import React, { useCallback, useState } from "react"

import { PageTitle, SectionTitle, Block, BlockTitle } from "@sandbox/Sandbox"
import Kiosk from "@ui/Kiosk"
import { OptinsRaw } from "."
import { answerAnOptin, buildOptinsAnsweredInfo, choiceType, OPTIN_TYPES, OptinAnsweredInfo, OptinInfo, OptinUID } from "@context/OptinsContext"

const ALL_OPTINS: OptinInfo[] = OPTIN_TYPES.map((uid) => ({
  explicit: uid.indexOf('PANINI_') !== 0,
  mandatory: uid === 'CONTEST',
  uid,
  accepted: choiceType(uid) === 'checkbox' ? false : undefined,
}))

const Sandbox: React.FC = () => {
  const [state, setState] = useState<{error?: string, busy: boolean, answeredInfos: OptinAnsweredInfo[]}>({
    busy: false,
    answeredInfos: buildOptinsAnsweredInfo(ALL_OPTINS),
  });

  const setOption = useCallback((uid: OptinUID, accepted: boolean) => {
    setState((prev) => ({
      ...prev,
      answeredInfos: answerAnOptin(prev.answeredInfos, uid, accepted)
    }))
  }, [])

  return <>
    <SectionTitle>
      <a onClick={() => setState((prev) => ({...prev, busy: !prev.busy}))}>toggle busy</a>
      {" | "}
      <a onClick={() => setState((prev) => ({...prev, error: prev.error ? undefined : 'You need to accept the terms'}))}>toggle error</a>
    </SectionTitle>
    <Kiosk>
      <OptinsRaw
        busy={state.busy}
        answeredInfos={state.answeredInfos}
        setOptin={setOption}
        error={state.error}
        submit={() => console.log("SEND", state.answeredInfos)} />
    </Kiosk>
  </>
}

export default ["Optins", Sandbox]
